<!--
  [placeholder]="placeholder !== '' ? placeholder : ' '"
  is necessary because PrimeNG internally uses this.placeholder || 'empty'.
  An empty string ('') is treated as falsy and replaced with the default value 'empty'.
  Setting a single space (' ') avoids this fallback and prevents 'empty' from being shown as the placeholder.
-->
<p-multiSelect
  (resized)="onResized($event)"
  optionLabel="displayLabel"
  dataKey="value"
  [showHeader]="true"
  [showToggleAll]="false"
  [options]="options"
  [(ngModel)]="selectedOptions"
  (onChange)="update()"
  [autofocusFilter]="false"
  [disabled]="disabled"
  [filter]="displayFilterInput"
  appendTo="body"
  [placeholder]="placeholder !== '' ? placeholder : ' '"
  [panelStyle]="panelStyle"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  [virtualScrollOptions]="{ style: { 'overflow-x': 'hidden', 'height': '200px' } }"
>
  <ng-template pTemplate="selectedItems">
    @if (selectedOptions.length <= maxSelectedLabels) {
      @for (item of selectedOptions; track item.value; let last = $last) {
        {{ !translateItems && !item.translate ? item.displayLabel : (item.displayLabel | translate)
        }}{{ last ? '' : ', ' }}
      }
    } @else {
      {{ selectedOptions.length }} {{ 'multiSelect.itemsSelected' | translate }}
    }
  </ng-template>

  <ng-template let-item pTemplate="item">
    @if (item.metas?.assetIcon) {
      <app-asset-icon [asset]="item.metas.assetIcon"></app-asset-icon>
    } @else if (item.icon) {
      <i [innerHtml]="item.icon" [ngStyle]="{ color: item.iconColor }"></i>
    }
    <span class="label">{{
      !translateItems && !item.translate ? item.displayLabel : (item.displayLabel | translate)
    }}</span>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="multiselect-footer">
      <hr />
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        label="{{ 'multiselect-control.footer.remove-selected-label' | translate }}"
        class="ui-button-bare"
        [disabled]="!enableUnselectAll"
        (click)="unSelectAll($event)"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-check"
        label="{{ 'multiselect-control.footer.select-all-label' | translate }}"
        class="ui-button-bare"
        [disabled]="!enableSelectAll"
        (click)="selectAll()"
      ></button>
    </div>
  </ng-template>
</p-multiSelect>
